import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { ReorderMarketingFlowStepsPayload } from "../../marketing.types";
import { requestReorderMarketingFlowSteps } from "./reorderMarketingFlowSteps.request";

const useReorderMarketingFlowSteps = (
  options?: MutationOptions<
    { ok: boolean },
    ApiServiceError<ApiError>,
    ReorderMarketingFlowStepsPayload
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: requestReorderMarketingFlowSteps,
    ...options,
    onSuccess: (data, variables, ctx) => {
      void queryClient.invalidateQueries({ queryKey: ["marketing", "flows"] });
      options?.onSuccess?.(data, variables, ctx);
    }
  });
};

export default useReorderMarketingFlowSteps;
